import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import AvatarService from '../../services/avatar';
import type { Action } from '../../state/actions';
import { projectContextSelector } from '../../state/context/selectors';
import type { AppState } from '../../state/types';
import { UPLOAD_AVATAR, uploadAvatarFail, uploadAvatarSuccess } from '../../state/ui/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	action$.ofType(UPLOAD_AVATAR).mergeMap(({ payload, meta }) =>
		Observable.fromPromise(
			AvatarService.uploadAvatar(projectContextSelector(store.getState()), payload),
		)
			.map((avatarDetails) => uploadAvatarSuccess(avatarDetails, meta.analyticsEvent))
			.catch((error) => Observable.of(uploadAvatarFail(error))),
	);
